// extracted by mini-css-extract-plugin
export default {"root":"BottomContent__root--34K9c"};